<Slide :i :slide>
    <slot>
    {{#if slide.text}}
        <div class="slide__text">
            <div class="slide__text-inner">{{ slide.text }}</div>
        </div>
    {{/if}}

    {{#if slide.text_list}}
        <div class="slide__bullet-group">
            {{#each slide.text_list as text_item, n}}
                <div class="slide__text slide__text--{{ n + 1 }} step">
                    <div class="slide__text-outer">
                        {{#if text_item.type == 'Text'}}
                            <p class="slide__text-inner">{{ text_item.text }}</p>
                        {{elseif text_item.type == 'Video' }}
                            <Modal slideIndex={{i}} modalIndex={{n}} modal={{text_item}} />
                        {{elseif text_item.type == 'Aside' }}
                            <Modal slideIndex={{i}} modalIndex={{n}} modal={{$science_asides[text_item.slug]}} />
                        {{else}}
                            <p class="slide__text-inner">{{ text_item }}</p> 
                        {{/if}}
                    </div>
                </div>
            {{/each}}
            <span class="slide__text-bg"></span>
        </div>
    {{/if}}
    </slot>

    {{#if rendered || render}}
    <VideoPlayer :i :slide :chapter />
    {{/if}}

</Slide>

<script>
import Slide from './Slide.html'
import VideoPlayer from './VideoPlayer.html'
import Modal from './Modal.html'

import { fade } from 'svelte-transitions'

export default {

    components: {
        Slide,
        VideoPlayer,
        Modal,
    },

    transitions: { fade },

    data() {
        return {
            slide: {},
        }
    },

    oncreate() {
        this.set({ rendered: false});

        /*
        this.store.observe( 'current_slide', current_slide => {
            if( this.get('i') == current_slide ) this.set({ rendered: true });
        });
        */

        this.observe( 'render', render => {
            if (render && !this.get('rendered') ) this.set({ rendered: true });
        });
    },

    computed: {
        render: ($current_slide, $current_chapter, i, rendered) => {
            if( rendered ) return true;
            if( $current_slide < 3 && i < 4 ) return true;  
            if( $current_slide >= 3 && i >= 4 ) return true;
            return false;
        },
    }
}
</script>